import { Component, Inject, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UntypedFormGroup } from '@angular/forms';
import { DialogData } from 'src/app/page/masterdata/apr-rates/apr-rates.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-add-apr-rate',
    templateUrl: './add-apr-rate.component.html',
    styleUrls: ['./add-apr-rate.component.scss'],
    standalone: false // NOSONAR
})
export class AddAprRateComponent implements OnInit {
  successMessage = '';
  errorMessage = '';

  myForm: UntypedFormGroup;
  rateId = "Auto assigned";
  fiscalyear;
  domicile;
  otr;
  handling;
  enableError: boolean = false;
  action;
  heading;
  errormsg: string;
  
  dynamicHeight: number;

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService,
     @Inject(MAT_DIALOG_DATA) public dataStore: DialogData, private readonly dialogRef: MatDialogRef<AddAprRateComponent>) {

      this.dynamicHeight = 0.665 * (window.innerHeight);
      this.fiscalyear = this.dataStore.placeholder_fiscalYear;  // Common for both add and edit flows

      if (this.dataStore.performAction == 'EditCell') { // NOSONAR
        this.heading = "Edit";
        this.action = 'EditCell';
  
        console.info("Fiscal Year passed onto Edit dialog", this.dataStore.placeholder_fiscalYear);

        this.rateId = this.dataStore.placeholder_rateId;
        this.domicile = this.dataStore.placeholder_domicile;
        this.otr = this.dataStore.placeholder_otr;
        this.handling = this.dataStore.placeholder_handling;
      }
      else {
        console.info("Fiscal Year passed onto Add dialog", this.dataStore.placeholder_fiscalYear);
        this.heading = "Add";
        this.action = 'AddCell';
      }
  }

  ngOnInit(): void { // NOSONAR 

  }

	onNoClick(): void {
		this.dialogRef.close();
	}

	close(): void {
		this.dialogRef.close();
	}

  public saveClick() {
    console.info("Rate Id", this.rateId);
    console.info("Fiscal Year being saved", this.fiscalyear);
    console.info("Domicile", this.domicile);
    console.info("OTR", this.otr);
    console.info("Handling", this.handling);

    if (this.domicile == '' || this.domicile == null || this.domicile == undefined || this.domicile.trim().length == 0 || this.otr == null || this.otr == undefined || this.handling == null || this.handling == undefined) { // NOSONAR
      this.enableError = true;
      this.errormsg = 'Please fill in the required fields!';
    }
    else {
      this.dialogRef.close({
        event: this.action, data0: this.rateId, data1: this.fiscalyear,
        data2: this.domicile, data3: this.otr, data4: this.handling
      });
    }
  }

}